import { render, staticRenderFns } from "./DiagnosisPlanDelete.vue?vue&type=template&id=78bfd931&scoped=true&"
import script from "./DiagnosisPlanDelete.vue?vue&type=script&lang=js&"
export * from "./DiagnosisPlanDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bfd931",
  null
  
)

export default component.exports